var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxPinRightOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7531 13.0148C13.9492 13.2093 13.9506 13.5259 13.7562 13.7219C13.5617 13.918 13.2451 13.9194 13.0491 13.7249L13.4011 13.3699L13.7531 13.0148ZM9.80078 9.80005L10.1528 9.445L13.7531 13.0148L13.4011 13.3699L13.0491 13.7249L9.44873 10.1551L9.80078 9.80005Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 7.2627L5.0293 8.35547C5.27745 8.47965 5.46271 8.70155 5.54102 8.96777L6.74219 13.0508L13.0508 6.74219L8.96777 5.54102C8.70155 5.46271 8.47965 5.27745 8.35547 5.0293L7.2627 2.84375L2.84375 7.2627Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxPinRightOutline);
export default __webpack_public_path__ + "static/media/icon_16px_pin-right_outline.30ff7308ea0999ee07deccf43f1eb328.svg";
export { ForwardRef as ReactComponent };